import {
  automotiveClassificationGetLabel,
  automotiveClassificationTypesGetLabel,
  isClassificationInventoryListingConfigOrEmpty
} from "@dealer-center/ddc-pages-inventory-config-interface";
import type { getDifferencesBetweenConfigsReturn } from ".";

export function RenderClassificationChange(
  change: getDifferencesBetweenConfigsReturn
) {
  if (
    isClassificationInventoryListingConfigOrEmpty(change.oldValue) &&
    isClassificationInventoryListingConfigOrEmpty(change.newValue)
  ) {
    const oldClassificationValuesAsString = change.oldValue.map(item =>
      automotiveClassificationGetLabel(item.classification)
    );
    const oldClassificationTypesValuesAsString = change.oldValue.map(item =>
      automotiveClassificationTypesGetLabel(item.type)
    );
    const newClassificationValuesAsString = change.newValue.map(item =>
      automotiveClassificationGetLabel(item.classification)
    );
    const newClassificationTypesValuesAsString = change.newValue.map(item =>
      automotiveClassificationTypesGetLabel(item.type)
    );

    return (
      <li>
        <b>{change.config}</b> changed from{" "}
        <b>
          "{oldClassificationValuesAsString.join(", ")}":"
          {oldClassificationTypesValuesAsString.join(", ")}"
        </b>{" "}
        to{" "}
        <b>
          "{newClassificationValuesAsString.join(", ")}": "
          {newClassificationTypesValuesAsString.join(", ")}
        </b>
        "
      </li>
    );
  }
  return null;
}
